import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e28739b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "body pt-3" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "mt-3 mw-700" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_dato_aggiuntivo = _resolveComponent("dato-aggiuntivo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        class: "d-block mb-2 text-center",
        localizedKey: "Richiedi Appuntamento",
        text: "Richiedi Appuntamento"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createVNode(_component_localized_text, {
          class: "d-block mb-2 medium",
          text: "Tipologia di prenotazione",
          localizedKey: "Tipologia di prenotazione"
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["btn h-auto cursor_default me-2", {
                            'primary filled':
                            !_ctx.boughtPackageIdentifier &&
                            _ctx.remainingBooking.remainingFreeBooking! > 0,
                        }])
          }, [
            (_ctx.remainingBooking.remainingFreeBooking! > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_localized_text, {
                    class: "d-block medium subtext",
                    text: "Gratuita",
                    localizedKey: "Gratuita"
                  }),
                  _createVNode(_component_localized_text, {
                    class: "d-block",
                    text: "Disponibile",
                    localizedKey: "Disponibile"
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_localized_text, {
                    class: "d-block medium subtext",
                    text: "Gratuita",
                    localizedKey: "Gratuita"
                  }),
                  _createVNode(_component_localized_text, {
                    class: "d-block",
                    text: "Non disponibile",
                    localizedKey: "Non disponibile"
                  })
                ]))
          ], 2),
          (!_ctx.isRestrictedCategory)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["btn h-auto cursor_default me-2", {
                            'primary filled': _ctx.boughtPackageIdentifier,
                        }])
              }, [
                (_ctx.remainingBooking.availableBoughtPackages.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_localized_text, {
                        class: "d-block medium subtext",
                        text: "Pacchetto",
                        localizedKey: "Pacchetto"
                      }),
                      _createVNode(_component_localized_text, {
                        class: "d-block",
                        text: "Disponibile"
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_localized_text, {
                        class: "d-block medium subtext",
                        text: "Pacchetto",
                        localizedKey: "Pacchetto"
                      }),
                      _createVNode(_component_localized_text, {
                        class: "d-block",
                        text: "Non disponibile",
                        localizedKey: "Non disponibile"
                      })
                    ]))
              ], 2))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredBaseFields, (field) => {
          return (_openBlock(), _createBlock(_component_dato_aggiuntivo, {
            class: "mt-3",
            key: field.identifier,
            config: field,
            modelValue: _ctx.additionalData,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.additionalData) = $event))
          }, null, 8, ["config", "modelValue"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          role: "button",
          "aria-label": "",
          type: "button",
          class: "btn btn-block btn-primary noShadow",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args))),
          disabled: _ctx.disabled
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Invia Richiesta",
            text: "Invia Richiesta"
          })
        ], 8, _hoisted_10),
        _createElementVNode("button", {
          role: "button",
          "aria-label": "",
          type: "button",
          class: "btn btn-block btn-white noShadow mt-3",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ko && _ctx.ko(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Annulla",
            text: "Annulla"
          })
        ])
      ])
    ])
  ]))
}